import { render, staticRenderFns } from "./SetPasswordFree.vue?vue&type=template&id=3f216b0e"
import script from "./SetPasswordFree.vue?vue&type=script&lang=ts"
export * from "./SetPasswordFree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports